import { ItemPageBreadcrumbsPluginModel } from '@marketplace-web/domain/item-page-data'

export const getItemPageBreadcrumbsPluginModel = (
  data: ItemPageBreadcrumbsPluginModel,
): ItemPageBreadcrumbsPluginModel => ({
  breadcrumbs: data.breadcrumbs.map(breadcrumb => ({
    title: breadcrumb.title,
    url: breadcrumb.url,
  })),
})
